import { useEffect, useState } from 'react';
import { api } from '../api.js';
import { centsToEurString, eurToCents } from '@csoki/shared';

type Row = {
  id: string;
  productBarcode: string;
  productName: string;
  imageUrl: string | null;
  priceCents: number;
  stock: number;
};

export function SellerListings() {
  const [rows, setRows] = useState<Row[] | null>(null);
  const [err, setErr] = useState<string | null>(null);

  async function load() {
    try {
      const { listings } = await api<{ listings: Row[] }>('GET', '/api/seller/listings');
      setRows(listings);
    } catch (e) {
      setErr((e as Error).message);
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function save(id: string, priceStr: string, stockStr: string) {
    try {
      const body: { priceCents?: number; stock?: number } = {};
      if (priceStr.trim()) body.priceCents = eurToCents(priceStr);
      if (stockStr.trim()) body.stock = Number(stockStr);
      await api('PATCH', `/api/listings/${id}`, body);
      await load();
    } catch (e) {
      alert((e as Error).message);
    }
  }

  async function del(id: string) {
    if (!confirm('Delete this listing?')) return;
    await api('DELETE', `/api/listings/${id}`);
    await load();
  }

  if (!rows) return <div className="page">Loading…</div>;

  return (
    <div className="page">
      <h1>My listings</h1>
      {err && <div className="err">{err}</div>}
      {rows.length === 0 && <p>Nothing listed yet.</p>}
      <ul className="listings stagger">
        {rows.map((r) => (
          <ListingRow key={r.id} row={r} onSave={save} onDelete={del} />
        ))}
      </ul>
    </div>
  );
}

function ListingRow({
  row,
  onSave,
  onDelete,
}: {
  row: Row;
  onSave: (id: string, priceStr: string, stockStr: string) => Promise<void>;
  onDelete: (id: string) => Promise<void>;
}) {
  const [price, setPrice] = useState(centsToEurString(row.priceCents));
  const [stock, setStock] = useState(String(row.stock));
  return (
    <li className="listing-row">
      {row.imageUrl && <img src={row.imageUrl} alt="" />}
      <div className="grow">
        <div className="title">{row.productName}</div>
        <div className="meta">
          <label>
            €<input value={price} onChange={(e) => setPrice(e.target.value)} size={6} />
          </label>
          <label>
            ×<input value={stock} onChange={(e) => setStock(e.target.value)} size={4} type="number" min={0} />
          </label>
        </div>
      </div>
      <button onClick={() => onSave(row.id, price, stock)}>Save</button>
      <button onClick={() => onDelete(row.id)} className="danger">
        ✕
      </button>
    </li>
  );
}
